import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './OpalPlanSelectionDateModal.css';
import { createPortal } from "react-dom";
import TauriLoader2 from '../../TauriLoader2/TauriLoader2';
import { useState } from 'react';
import { getAll } from '../../../localDB';
import DatePicker from 'react-datepicker';
import TauriImage from '../../TauriImage/TauriImage';

const OpalPlanSelectionDateModal = ({
    show,
    onHide,
    loading,
    onClick
}) => {

    const [selectedDate, setSelectedDate] = useState(null);
    const [cycle, setCycle] = useState([]);
    const [cyclePeriod, setCyclePeriod] = useState(null);

    const handleDateChange = (date) => {
        if (!date) return;

        date.setHours(0, 0, 0, 0); // normalize
        setSelectedDate(date);

        const foundCycle = cycle.find(c => {
            const start = new Date(c.StartDate);
            start.setHours(0, 0, 0, 0);
            const end = new Date(c.EndDate);
            end.setHours(0, 0, 0, 0);
            return date >= start && date <= end;
        });

        setCyclePeriod(foundCycle);
    };

    const fetchDataCyclePeriod = async () => {
        try {
            const cycleList = await getAll("Cycle");
            setCycle(cycleList);
        } catch (error) {
            console.log('error fetching..');
        }
    };

    useEffect(() => {
        if (show) {
            fetchDataCyclePeriod();
        }
    }, [show]);

    // Run once cycles are fetched
    useEffect(() => {
        if (cycle.length > 0) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            handleDateChange(today); // single call
        }
    }, [cycle]);


    return createPortal(
        <Modal
            className='opal-plan-selectiondate-modal'
            show={show}
            onHide={onHide}
            centered
        >
            <Modal.Header>Create Coverage Plan</Modal.Header>
            <Modal.Body>
                <div className="d-flex align-items-center justify-content-center">
                    <DatePicker
                        selected={selectedDate}
                        onChange={handleDateChange}
                        dateFormat="EEEE, MMMM d"
                        customInput={
                            <div className="datepicker-input">
                                <span className="datepicker-text">
                                    {cyclePeriod ? (
                                        <><span className='cycle-code'>{cyclePeriod?.Code}</span> - {cyclePeriod?.Description}</>
                                    ) : "No cycle period available"
                                    }
                                </span>
                                <TauriImage localImage="/Images/arrow-down.svg" alt="arrow-down" className="dt-arrowdown" color={"#000"} />
                            </div>
                        }
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className='opal-alert-confirm'
                    disabled={loading}
                    onClick={() => onClick(cyclePeriod)}
                >
                    {loading && (
                        <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#000" />
                    )}
                    <span className="ms-2 text-nowrap">Proceed</span>
                </Button>
                <Button className='opal-alert-close' onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>,
        document.body
    );
};

export default OpalPlanSelectionDateModal;
